export const weeklySummaryBundle = {
  statusTitle: {
    ko: "주간 단지 현황",
    en: "Weekly Complex Status",
    es: "Estado del complejo semanal"
  },
  totalUnits: {
    ko: "총 {total}세대",
    en: "Total {total} Units",
    es: "Total de {total} unidades"
  },
  normalUnits: {
    ko: "정상 세대",
    en: "Normal Units",
    es: "Unidades normales"
  },
  suspectedLeaks: {
    ko: "누수 의심",
    en: "Suspected Leaks",
    es: "Sospecha de fugas"
  },
  expectedLossAmount: {
    ko: "손실 예상 요금",
    en: "Expected Loss Amount",
    es: "Monto de pérdida esperado"
  },
  leakRatePercentage: {
    ko: "전체 요금의 {rate}%",
    en: "{rate}% of total bill",
    es: "{rate}% del total de la factura"
  },
  waterUsageBill: {
    ko: "수도 사용 요금",
    en: "Water Usage Bill",
    es: "Factura de consumo de agua"
  },
  currencyUnit: {
    ko: "원",
    en: "KRW",
    es: "KRW"
  }
}
